import { AdminHeader } from 'components/admin/header/AdminHeader';
import { Page } from 'elements/admin/layout/Page';
import { ReverseButton } from 'elements/eventView/atomic/ReverseButton';
import { useEffect } from 'react';
import styled from 'styled-components/macro';

export const LandingRedirect = (): JSX.Element => {
    const isLocalhost = window.location.hostname === 'localhost';
    const redirectUrl = isLocalhost ? 'http://localhost:3000/admin' : 'https://mapheim.com';

    useEffect(() => {
        window.location.href = redirectUrl;
    }, []);

    window.location.href = redirectUrl;

    return (
        <S_LandingRedirect>
            <AdminHeader />
            <ReverseButton
                text="Redirect to Mapheim"
                iconName="arrow-right"
                onClick={() => {
                    window.location.href = 'https://mapheim.com';
                }}
            />
        </S_LandingRedirect>
    );
};

const S_LandingRedirect = styled(Page)``;
